import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9e6e8ec0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "article-box"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "article-content"
};
const _hoisted_4 = {
  class: "article-image",
  style: {}
};
const _hoisted_5 = ["src"];
import { computed, onMounted, ref } from "vue";
import { XiaoniuFrontedControllerService } from "../../../generated/services/XiaoniuFrontedControllerService";
import { SysDictDataControllerService } from "../../../generated";
import { beautifyTime } from "@/plugins/time";
import { LikeOutlined, MessageOutlined, StarOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import "../../styles/home/HotArticle.scss";
export default /*#__PURE__*/_defineComponent({
  __name: 'MyHotArticle',
  setup(__props) {
    const actions = [{
      icon: StarOutlined,
      text: '156'
    }, {
      icon: LikeOutlined,
      text: '156'
    }, {
      icon: MessageOutlined,
      text: '2'
    }];
    const articleList = ref([]);
    const initArticleList = async () => {
      const res = await XiaoniuFrontedControllerService.topEightArticlesUsingGet();
      if (res.code === 200) {
        const resList = res.data;
        resList.forEach(item => {
          articleList.value.push({
            id: item.id,
            href: '#',
            title: item.title,
            avatar: 'http://ocr.nbdj.cc/test/profile.jpg',
            description: formatterDescription(item.type, item.updateTime),
            content: item.overview,
            imagesList: item.imagesList
          });
        });
      }
    };
    //将类型转为文章实际的文字
    const formatterDescription = (type, time) => {
      //将type转为文字
      let typeName = '';
      let formatterTime = '';
      if (type != null) {
        typeName = articleDictList.value.find(item => Number(item.dictValue) === Number(type))?.dictLabel || '';
      }
      if (time != null) {
        let timeStamp = new Date(time).getTime();
        formatterTime = beautifyTime(timeStamp);
      }
      return typeName + ' ' + formatterTime;
    };
    //获取文章类型数据
    const dicType = ref("blog_type");
    const articleDictList = ref([]);
    const getDictArticleData = () => {
      //获取字典数据
      SysDictDataControllerService.dictTypeUsingGet(dicType.value).then(res => {
        if (res.code === 200) {
          articleDictList.value = res.data;
        }
      });
    };
    // 判断是否为移动端
    const isMobile = computed(() => {
      const screenWidth = window.innerWidth;
      // 屏幕宽度的阈值
      const mobileScreenWidthThreshold = 768;
      if (screenWidth <= mobileScreenWidthThreshold) {
        return true;
      } else {
        return false;
      }
    });
    // 动态设置Avatar样式
    const avatarStyle = computed(() => {
      return {
        marginTop: '2px',
        marginLeft: isMobile.value ? '0px' : '10px'
      };
    });
    onMounted(() => {
      //获取文章字典数据
      getDictArticleData();
      //初始化热门文章
      initArticleList();
    });
    //点击文章跳转
    const router = useRouter();
    const clickArticle = item => {
      router.push(`/article/detail/${item.id}`);
    };
    return (_ctx, _cache) => {
      const _component_a_avatar = _resolveComponent("a-avatar");
      const _component_a_list_item_meta = _resolveComponent("a-list-item-meta");
      const _component_a_list_item = _resolveComponent("a-list-item");
      const _component_a_list = _resolveComponent("a-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_list, {
        "item-layout": 'vertical',
        "data-source": articleList.value
      }, {
        renderItem: _withCtx(({
          item
        }) => [_createVNode(_component_a_list_item, {
          key: "item.title",
          class: "hover-wrapper",
          onClick: $event => clickArticle(item)
        }, {
          actions: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(actions, ({
            icon,
            text
          }) => {
            return _createElementVNode("span", {
              key: icon,
              class: "article-collection-comment-goods"
            }, [(_openBlock(), _createBlock(_resolveDynamicComponent(icon), {
              style: {
                "margin-right": "8px"
              }
            })), _createTextVNode(" " + _toDisplayString(text), 1)]);
          }), 64))]),
          default: _withCtx(() => [_createVNode(_component_a_list_item_meta, {
            description: item.description,
            style: {
              "margin-top": "8px"
            }
          }, {
            title: _withCtx(() => [_createElementVNode("a", {
              href: item.href,
              style: {
                "font-size": "18px"
              }
            }, _toDisplayString(item.title), 9, _hoisted_2)]),
            avatar: _withCtx(() => [_createVNode(_component_a_avatar, {
              style: _normalizeStyle(avatarStyle.value),
              src: item.avatar
            }, null, 8, ["style", "src"])]),
            _: 2
          }, 1032, ["description"]), _createElementVNode("div", _hoisted_3, _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imagesList, image => {
            return _openBlock(), _createElementBlock("img", {
              key: image.id,
              style: {
                "padding": "8px"
              },
              width: "250",
              height: "160",
              alt: "logo",
              src: image.url
            }, null, 8, _hoisted_5);
          }), 128))])]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data-source"])]);
    };
  }
});